import styled from '@emotion/styled';
import { Magnetic } from "../../styles";
export const StyledLink = styled('a')((props) => `
    text-decoration: underline;
    margin-left: ${Magnetic.spacer04};
	margin-right: ${Magnetic.spacer04};
    color: ${props.color ? props.color : Magnetic.colorBlack}
`);
export const StyledRetryLink = styled('a') `
	text-decoration: ${Magnetic.uamAnchorTextDecoration};
	color: ${Magnetic.colorBrand50};
	padding-right: ${Magnetic.spacer04};
`;
export const BannerElementStyle = styled('div')((props) => `    
    cursor: ${props.showPointer ? 'pointer' : 'default'}
`);
//# sourceMappingURL=banner.style.js.map